// source: io/codedrills/proto/site/content_view_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_content_pb);
var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_preview_pb);
var io_codedrills_proto_content_view_pb = require('../../../../io/codedrills/proto/content/view_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_view_pb);
var io_codedrills_proto_content_scoring_pb = require('../../../../io/codedrills/proto/content/scoring_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_scoring_pb);
var io_codedrills_proto_content_pagination_pb = require('../../../../io/codedrills/proto/content/pagination_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_pagination_pb);
goog.exportSymbol('proto.io.codedrills.proto.site.DataType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.FetchCustomerAllTestRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.FetchCustomerAllTestResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetAttachmentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetAttachmentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetChildPreviewsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetChildPreviewsResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetContentPreviewRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetContentPreviewResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetContentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetContentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetContentViewRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetContentViewResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetContestScoreboardRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetContestScoreboardResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetParentPreviewsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetParentPreviewsResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetRestrictedContestsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.GetRestrictedContestsResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.ListContentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.ListContentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.ListCustomerContentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.ListCustomerContentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.RefreshScoreboardRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.RefreshScoreboardResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.UserContentPreviewsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.site.UserContentPreviewsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.ListContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.site.ListContentRequest.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.site.ListContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.ListContentRequest.displayName = 'proto.io.codedrills.proto.site.ListContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.ListContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.site.ListContentResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.site.ListContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.ListContentResponse.displayName = 'proto.io.codedrills.proto.site.ListContentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetContentViewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetContentViewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetContentViewRequest.displayName = 'proto.io.codedrills.proto.site.GetContentViewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetContentViewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetContentViewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetContentViewResponse.displayName = 'proto.io.codedrills.proto.site.GetContentViewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetContentRequest.displayName = 'proto.io.codedrills.proto.site.GetContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetContentResponse.displayName = 'proto.io.codedrills.proto.site.GetContentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetAttachmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetAttachmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetAttachmentRequest.displayName = 'proto.io.codedrills.proto.site.GetAttachmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetAttachmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetAttachmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetAttachmentResponse.displayName = 'proto.io.codedrills.proto.site.GetAttachmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.site.UserContentPreviewsRequest.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.site.UserContentPreviewsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.UserContentPreviewsRequest.displayName = 'proto.io.codedrills.proto.site.UserContentPreviewsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.site.UserContentPreviewsResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.site.UserContentPreviewsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.UserContentPreviewsResponse.displayName = 'proto.io.codedrills.proto.site.UserContentPreviewsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetContestScoreboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetContestScoreboardRequest.displayName = 'proto.io.codedrills.proto.site.GetContestScoreboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetContestScoreboardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetContestScoreboardResponse.displayName = 'proto.io.codedrills.proto.site.GetContestScoreboardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.displayName = 'proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.displayName = 'proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetContentPreviewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetContentPreviewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetContentPreviewRequest.displayName = 'proto.io.codedrills.proto.site.GetContentPreviewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetContentPreviewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetContentPreviewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetContentPreviewResponse.displayName = 'proto.io.codedrills.proto.site.GetContentPreviewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetParentPreviewsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetParentPreviewsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetParentPreviewsRequest.displayName = 'proto.io.codedrills.proto.site.GetParentPreviewsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.site.GetParentPreviewsResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetParentPreviewsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetParentPreviewsResponse.displayName = 'proto.io.codedrills.proto.site.GetParentPreviewsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetChildPreviewsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetChildPreviewsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetChildPreviewsRequest.displayName = 'proto.io.codedrills.proto.site.GetChildPreviewsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.site.GetChildPreviewsResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetChildPreviewsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetChildPreviewsResponse.displayName = 'proto.io.codedrills.proto.site.GetChildPreviewsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetRestrictedContestsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetRestrictedContestsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetRestrictedContestsRequest.displayName = 'proto.io.codedrills.proto.site.GetRestrictedContestsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.site.GetRestrictedContestsResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.site.GetRestrictedContestsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.GetRestrictedContestsResponse.displayName = 'proto.io.codedrills.proto.site.GetRestrictedContestsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.RefreshScoreboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.RefreshScoreboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.RefreshScoreboardRequest.displayName = 'proto.io.codedrills.proto.site.RefreshScoreboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.RefreshScoreboardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.RefreshScoreboardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.RefreshScoreboardResponse.displayName = 'proto.io.codedrills.proto.site.RefreshScoreboardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.FetchCustomerAllTestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.displayName = 'proto.io.codedrills.proto.site.FetchCustomerAllTestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.site.FetchCustomerAllTestResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.displayName = 'proto.io.codedrills.proto.site.FetchCustomerAllTestResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.site.ListCustomerContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.ListCustomerContentRequest.displayName = 'proto.io.codedrills.proto.site.ListCustomerContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.site.ListCustomerContentResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.site.ListCustomerContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.site.ListCustomerContentResponse.displayName = 'proto.io.codedrills.proto.site.ListCustomerContentResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.site.ListContentRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.ListContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.ListContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.ListContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.ListContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.ListContentRequest}
 */
proto.io.codedrills.proto.site.ListContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.ListContentRequest;
  return proto.io.codedrills.proto.site.ListContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.ListContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.ListContentRequest}
 */
proto.io.codedrills.proto.site.ListContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setContentType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.ListContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.ListContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.ListContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.ListContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContentType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.site.ListContentRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.site.ListContentRequest} returns this
 */
proto.io.codedrills.proto.site.ListContentRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional io.codedrills.proto.content.ContentType content_type = 2;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.site.ListContentRequest.prototype.getContentType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.site.ListContentRequest} returns this
 */
proto.io.codedrills.proto.site.ListContentRequest.prototype.setContentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated string tags = 3;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.site.ListContentRequest.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.site.ListContentRequest} returns this
 */
proto.io.codedrills.proto.site.ListContentRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.site.ListContentRequest} returns this
 */
proto.io.codedrills.proto.site.ListContentRequest.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.ListContentRequest} returns this
 */
proto.io.codedrills.proto.site.ListContentRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.site.ListContentResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.ListContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.ListContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.ListContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.ListContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentsList: jspb.Message.toObjectList(msg.getContentsList(),
    io_codedrills_proto_content_preview_pb.ContentPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.ListContentResponse}
 */
proto.io.codedrills.proto.site.ListContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.ListContentResponse;
  return proto.io.codedrills.proto.site.ListContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.ListContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.ListContentResponse}
 */
proto.io.codedrills.proto.site.ListContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.addContents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.ListContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.ListContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.ListContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.ListContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.ContentPreview contents = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.ContentPreview>}
 */
proto.io.codedrills.proto.site.ListContentResponse.prototype.getContentsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ContentPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ContentPreview>} value
 * @return {!proto.io.codedrills.proto.site.ListContentResponse} returns this
*/
proto.io.codedrills.proto.site.ListContentResponse.prototype.setContentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.site.ListContentResponse.prototype.addContents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.ContentPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.ListContentResponse} returns this
 */
proto.io.codedrills.proto.site.ListContentResponse.prototype.clearContentsList = function() {
  return this.setContentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetContentViewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetContentViewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetContentViewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentViewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    parentId: (f = msg.getParentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetContentViewRequest}
 */
proto.io.codedrills.proto.site.GetContentViewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetContentViewRequest;
  return proto.io.codedrills.proto.site.GetContentViewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetContentViewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetContentViewRequest}
 */
proto.io.codedrills.proto.site.GetContentViewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setParentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetContentViewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetContentViewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetContentViewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentViewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getParentId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.site.GetContentViewRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContentViewRequest} returns this
*/
proto.io.codedrills.proto.site.GetContentViewRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContentViewRequest} returns this
 */
proto.io.codedrills.proto.site.GetContentViewRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContentViewRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.codedrills.proto.content.ContentId parent_id = 2;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.site.GetContentViewRequest.prototype.getParentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContentViewRequest} returns this
*/
proto.io.codedrills.proto.site.GetContentViewRequest.prototype.setParentId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContentViewRequest} returns this
 */
proto.io.codedrills.proto.site.GetContentViewRequest.prototype.clearParentId = function() {
  return this.setParentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContentViewRequest.prototype.hasParentId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetContentViewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetContentViewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetContentViewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentViewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentView: (f = msg.getContentView()) && io_codedrills_proto_content_view_pb.ContentView.toObject(includeInstance, f),
    parentPreview: (f = msg.getParentPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetContentViewResponse}
 */
proto.io.codedrills.proto.site.GetContentViewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetContentViewResponse;
  return proto.io.codedrills.proto.site.GetContentViewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetContentViewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetContentViewResponse}
 */
proto.io.codedrills.proto.site.GetContentViewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_view_pb.ContentView;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.ContentView.deserializeBinaryFromReader);
      msg.setContentView(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setParentPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetContentViewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetContentViewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetContentViewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentViewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_view_pb.ContentView.serializeBinaryToWriter
    );
  }
  f = message.getParentPreview();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentView content_view = 1;
 * @return {?proto.io.codedrills.proto.content.ContentView}
 */
proto.io.codedrills.proto.site.GetContentViewResponse.prototype.getContentView = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentView} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.ContentView, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentView|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContentViewResponse} returns this
*/
proto.io.codedrills.proto.site.GetContentViewResponse.prototype.setContentView = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContentViewResponse} returns this
 */
proto.io.codedrills.proto.site.GetContentViewResponse.prototype.clearContentView = function() {
  return this.setContentView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContentViewResponse.prototype.hasContentView = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.codedrills.proto.content.ContentPreview parent_preview = 2;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.site.GetContentViewResponse.prototype.getParentPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContentViewResponse} returns this
*/
proto.io.codedrills.proto.site.GetContentViewResponse.prototype.setParentPreview = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContentViewResponse} returns this
 */
proto.io.codedrills.proto.site.GetContentViewResponse.prototype.clearParentPreview = function() {
  return this.setParentPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContentViewResponse.prototype.hasParentPreview = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetContentRequest}
 */
proto.io.codedrills.proto.site.GetContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetContentRequest;
  return proto.io.codedrills.proto.site.GetContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetContentRequest}
 */
proto.io.codedrills.proto.site.GetContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.site.GetContentRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContentRequest} returns this
*/
proto.io.codedrills.proto.site.GetContentRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContentRequest} returns this
 */
proto.io.codedrills.proto.site.GetContentRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContentRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.io.codedrills.proto.site.GetContentRequest.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.site.GetContentRequest} returns this
 */
proto.io.codedrills.proto.site.GetContentRequest.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    content: (f = msg.getContent()) && io_codedrills_proto_content_content_pb.Content.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetContentResponse}
 */
proto.io.codedrills.proto.site.GetContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetContentResponse;
  return proto.io.codedrills.proto.site.GetContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetContentResponse}
 */
proto.io.codedrills.proto.site.GetContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.Content;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.Content.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.Content.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.Content content = 1;
 * @return {?proto.io.codedrills.proto.content.Content}
 */
proto.io.codedrills.proto.site.GetContentResponse.prototype.getContent = function() {
  return /** @type{?proto.io.codedrills.proto.content.Content} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.Content, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.Content|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContentResponse} returns this
*/
proto.io.codedrills.proto.site.GetContentResponse.prototype.setContent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContentResponse} returns this
 */
proto.io.codedrills.proto.site.GetContentResponse.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContentResponse.prototype.hasContent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetAttachmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetAttachmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    attachmentId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetAttachmentRequest}
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetAttachmentRequest;
  return proto.io.codedrills.proto.site.GetAttachmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetAttachmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetAttachmentRequest}
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setAttachmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetAttachmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetAttachmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getAttachmentId();
  if (f !== 0) {
    writer.writeFixed32(
      2,
      f
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetAttachmentRequest} returns this
*/
proto.io.codedrills.proto.site.GetAttachmentRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetAttachmentRequest} returns this
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fixed32 attachment_id = 2;
 * @return {number}
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.prototype.getAttachmentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.site.GetAttachmentRequest} returns this
 */
proto.io.codedrills.proto.site.GetAttachmentRequest.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetAttachmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetAttachmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetAttachmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetAttachmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    attachment: (f = msg.getAttachment()) && io_codedrills_proto_content_content_pb.Attachment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetAttachmentResponse}
 */
proto.io.codedrills.proto.site.GetAttachmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetAttachmentResponse;
  return proto.io.codedrills.proto.site.GetAttachmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetAttachmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetAttachmentResponse}
 */
proto.io.codedrills.proto.site.GetAttachmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.Attachment;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.Attachment.deserializeBinaryFromReader);
      msg.setAttachment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetAttachmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetAttachmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetAttachmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetAttachmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.Attachment.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.Attachment attachment = 1;
 * @return {?proto.io.codedrills.proto.content.Attachment}
 */
proto.io.codedrills.proto.site.GetAttachmentResponse.prototype.getAttachment = function() {
  return /** @type{?proto.io.codedrills.proto.content.Attachment} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.Attachment, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.Attachment|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetAttachmentResponse} returns this
*/
proto.io.codedrills.proto.site.GetAttachmentResponse.prototype.setAttachment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetAttachmentResponse} returns this
 */
proto.io.codedrills.proto.site.GetAttachmentResponse.prototype.clearAttachment = function() {
  return this.setAttachment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetAttachmentResponse.prototype.hasAttachment = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.UserContentPreviewsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    typesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    contentIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    userId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    filterByTags: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    filterByContentType: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    filterByIds: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.UserContentPreviewsRequest;
  return proto.io.codedrills.proto.site.UserContentPreviewsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 2:
      var value = /** @type {!Array<!proto.io.codedrills.proto.content.ContentType>} */ (reader.readPackedEnum());
      msg.setTypesList(value);
      break;
    case 3:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setContentIdsList(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilterByTags(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilterByContentType(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilterByIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.UserContentPreviewsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getContentIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFilterByTags();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getFilterByContentType();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getFilterByIds();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * repeated string tags = 1;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * repeated io.codedrills.proto.content.ContentType types = 2;
 * @return {!Array<!proto.io.codedrills.proto.content.ContentType>}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.getTypesList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.content.ContentType>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ContentType>} value
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};


/**
 * repeated int32 content_ids = 3;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.getContentIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.setContentIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.addContentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.clearContentIdsList = function() {
  return this.setContentIdsList([]);
};


/**
 * optional string user_id = 4;
 * @return {string}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool filter_by_tags = 5;
 * @return {boolean}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.getFilterByTags = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.setFilterByTags = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool filter_by_content_type = 6;
 * @return {boolean}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.getFilterByContentType = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.setFilterByContentType = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool filter_by_ids = 7;
 * @return {boolean}
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.getFilterByIds = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsRequest.prototype.setFilterByIds = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.UserContentPreviewsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.UserContentPreviewsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentPreviewsList: jspb.Message.toObjectList(msg.getContentPreviewsList(),
    io_codedrills_proto_content_view_pb.UserContentPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsResponse}
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.UserContentPreviewsResponse;
  return proto.io.codedrills.proto.site.UserContentPreviewsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.UserContentPreviewsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsResponse}
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_view_pb.UserContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.UserContentPreview.deserializeBinaryFromReader);
      msg.addContentPreviews(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.UserContentPreviewsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.UserContentPreviewsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentPreviewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_view_pb.UserContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.UserContentPreview content_previews = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.UserContentPreview>}
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse.prototype.getContentPreviewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.UserContentPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_view_pb.UserContentPreview, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.UserContentPreview>} value
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsResponse} returns this
*/
proto.io.codedrills.proto.site.UserContentPreviewsResponse.prototype.setContentPreviewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.UserContentPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.UserContentPreview}
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse.prototype.addContentPreviews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.UserContentPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.UserContentPreviewsResponse} returns this
 */
proto.io.codedrills.proto.site.UserContentPreviewsResponse.prototype.clearContentPreviewsList = function() {
  return this.setContentPreviewsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetContestScoreboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contestId: (f = msg.getContestId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    dataType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    paginationQuery: (f = msg.getPaginationQuery()) && io_codedrills_proto_content_pagination_pb.PaginationQuery.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardRequest}
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetContestScoreboardRequest;
  return proto.io.codedrills.proto.site.GetContestScoreboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardRequest}
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContestId(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.site.DataType} */ (reader.readEnum());
      msg.setDataType(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationQuery;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationQuery.deserializeBinaryFromReader);
      msg.setPaginationQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetContestScoreboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContestId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getDataType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPaginationQuery();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationQuery.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId contest_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.getContestId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} returns this
*/
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.setContestId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} returns this
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.clearContestId = function() {
  return this.setContestId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.hasContestId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DataType data_type = 2;
 * @return {!proto.io.codedrills.proto.site.DataType}
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.getDataType = function() {
  return /** @type {!proto.io.codedrills.proto.site.DataType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.site.DataType} value
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} returns this
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.setDataType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional io.codedrills.proto.content.PaginationQuery pagination_query = 3;
 * @return {?proto.io.codedrills.proto.content.PaginationQuery}
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.getPaginationQuery = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationQuery} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationQuery, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationQuery|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} returns this
*/
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.setPaginationQuery = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} returns this
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.clearPaginationQuery = function() {
  return this.setPaginationQuery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContestScoreboardRequest.prototype.hasPaginationQuery = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetContestScoreboardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    scoreboardSnapshot: (f = msg.getScoreboardSnapshot()) && io_codedrills_proto_content_scoring_pb.ScoreboardSnapshot.toObject(includeInstance, f),
    paginationResponse: (f = msg.getPaginationResponse()) && io_codedrills_proto_content_pagination_pb.PaginationResponse.toObject(includeInstance, f),
    userScore: (f = msg.getUserScore()) && io_codedrills_proto_content_scoring_pb.UserScore.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardResponse}
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetContestScoreboardResponse;
  return proto.io.codedrills.proto.site.GetContestScoreboardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardResponse}
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_scoring_pb.ScoreboardSnapshot;
      reader.readMessage(value,io_codedrills_proto_content_scoring_pb.ScoreboardSnapshot.deserializeBinaryFromReader);
      msg.setScoreboardSnapshot(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationResponse;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_scoring_pb.UserScore;
      reader.readMessage(value,io_codedrills_proto_content_scoring_pb.UserScore.deserializeBinaryFromReader);
      msg.setUserScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetContestScoreboardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScoreboardSnapshot();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_scoring_pb.ScoreboardSnapshot.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
  f = message.getUserScore();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_scoring_pb.UserScore.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ScoreboardSnapshot scoreboard_snapshot = 1;
 * @return {?proto.io.codedrills.proto.content.ScoreboardSnapshot}
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.getScoreboardSnapshot = function() {
  return /** @type{?proto.io.codedrills.proto.content.ScoreboardSnapshot} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_scoring_pb.ScoreboardSnapshot, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ScoreboardSnapshot|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardResponse} returns this
*/
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.setScoreboardSnapshot = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardResponse} returns this
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.clearScoreboardSnapshot = function() {
  return this.setScoreboardSnapshot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.hasScoreboardSnapshot = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.codedrills.proto.content.PaginationResponse pagination_response = 2;
 * @return {?proto.io.codedrills.proto.content.PaginationResponse}
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationResponse|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardResponse} returns this
*/
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardResponse} returns this
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional io.codedrills.proto.content.UserScore user_score = 3;
 * @return {?proto.io.codedrills.proto.content.UserScore}
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.getUserScore = function() {
  return /** @type{?proto.io.codedrills.proto.content.UserScore} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_scoring_pb.UserScore, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.UserScore|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardResponse} returns this
*/
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.setUserScore = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContestScoreboardResponse} returns this
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.clearUserScore = function() {
  return this.setUserScore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContestScoreboardResponse.prototype.hasUserScore = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentAddress: (f = msg.getContentAddress()) && io_codedrills_proto_content_content_pb.ContentAddress.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest;
  return proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentAddress;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentAddress.deserializeBinaryFromReader);
      msg.setContentAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentAddress();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentAddress.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentAddress content_address = 1;
 * @return {?proto.io.codedrills.proto.content.ContentAddress}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.prototype.getContentAddress = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentAddress} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentAddress, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentAddress|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest} returns this
*/
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.prototype.setContentAddress = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest} returns this
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.prototype.clearContentAddress = function() {
  return this.setContentAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest.prototype.hasContentAddress = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse;
  return proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse} returns this
 */
proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetContentPreviewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetContentPreviewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetContentPreviewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentPreviewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetContentPreviewRequest}
 */
proto.io.codedrills.proto.site.GetContentPreviewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetContentPreviewRequest;
  return proto.io.codedrills.proto.site.GetContentPreviewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetContentPreviewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetContentPreviewRequest}
 */
proto.io.codedrills.proto.site.GetContentPreviewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetContentPreviewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetContentPreviewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetContentPreviewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentPreviewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.site.GetContentPreviewRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContentPreviewRequest} returns this
*/
proto.io.codedrills.proto.site.GetContentPreviewRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContentPreviewRequest} returns this
 */
proto.io.codedrills.proto.site.GetContentPreviewRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContentPreviewRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetContentPreviewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetContentPreviewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetContentPreviewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentPreviewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentPreview: (f = msg.getContentPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetContentPreviewResponse}
 */
proto.io.codedrills.proto.site.GetContentPreviewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetContentPreviewResponse;
  return proto.io.codedrills.proto.site.GetContentPreviewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetContentPreviewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetContentPreviewResponse}
 */
proto.io.codedrills.proto.site.GetContentPreviewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setContentPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetContentPreviewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetContentPreviewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetContentPreviewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetContentPreviewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentPreview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentPreview content_preview = 1;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.site.GetContentPreviewResponse.prototype.getContentPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetContentPreviewResponse} returns this
*/
proto.io.codedrills.proto.site.GetContentPreviewResponse.prototype.setContentPreview = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetContentPreviewResponse} returns this
 */
proto.io.codedrills.proto.site.GetContentPreviewResponse.prototype.clearContentPreview = function() {
  return this.setContentPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetContentPreviewResponse.prototype.hasContentPreview = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetParentPreviewsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetParentPreviewsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetParentPreviewsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetParentPreviewsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetParentPreviewsRequest}
 */
proto.io.codedrills.proto.site.GetParentPreviewsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetParentPreviewsRequest;
  return proto.io.codedrills.proto.site.GetParentPreviewsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetParentPreviewsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetParentPreviewsRequest}
 */
proto.io.codedrills.proto.site.GetParentPreviewsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetParentPreviewsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetParentPreviewsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetParentPreviewsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetParentPreviewsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.site.GetParentPreviewsRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetParentPreviewsRequest} returns this
*/
proto.io.codedrills.proto.site.GetParentPreviewsRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetParentPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.GetParentPreviewsRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetParentPreviewsRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetParentPreviewsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetParentPreviewsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentPreviewsList: jspb.Message.toObjectList(msg.getContentPreviewsList(),
    io_codedrills_proto_content_preview_pb.ContentPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetParentPreviewsResponse}
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetParentPreviewsResponse;
  return proto.io.codedrills.proto.site.GetParentPreviewsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetParentPreviewsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetParentPreviewsResponse}
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.addContentPreviews(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetParentPreviewsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetParentPreviewsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentPreviewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.ContentPreview content_previews = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.ContentPreview>}
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse.prototype.getContentPreviewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ContentPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ContentPreview>} value
 * @return {!proto.io.codedrills.proto.site.GetParentPreviewsResponse} returns this
*/
proto.io.codedrills.proto.site.GetParentPreviewsResponse.prototype.setContentPreviewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse.prototype.addContentPreviews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.ContentPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.GetParentPreviewsResponse} returns this
 */
proto.io.codedrills.proto.site.GetParentPreviewsResponse.prototype.clearContentPreviewsList = function() {
  return this.setContentPreviewsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetChildPreviewsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetChildPreviewsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetChildPreviewsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetChildPreviewsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetChildPreviewsRequest}
 */
proto.io.codedrills.proto.site.GetChildPreviewsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetChildPreviewsRequest;
  return proto.io.codedrills.proto.site.GetChildPreviewsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetChildPreviewsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetChildPreviewsRequest}
 */
proto.io.codedrills.proto.site.GetChildPreviewsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetChildPreviewsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetChildPreviewsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetChildPreviewsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetChildPreviewsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.site.GetChildPreviewsRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.site.GetChildPreviewsRequest} returns this
*/
proto.io.codedrills.proto.site.GetChildPreviewsRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.GetChildPreviewsRequest} returns this
 */
proto.io.codedrills.proto.site.GetChildPreviewsRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.GetChildPreviewsRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetChildPreviewsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetChildPreviewsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentPreviewsList: jspb.Message.toObjectList(msg.getContentPreviewsList(),
    io_codedrills_proto_content_preview_pb.ContentPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetChildPreviewsResponse}
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetChildPreviewsResponse;
  return proto.io.codedrills.proto.site.GetChildPreviewsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetChildPreviewsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetChildPreviewsResponse}
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.addContentPreviews(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetChildPreviewsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetChildPreviewsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentPreviewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.ContentPreview content_previews = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.ContentPreview>}
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse.prototype.getContentPreviewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ContentPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ContentPreview>} value
 * @return {!proto.io.codedrills.proto.site.GetChildPreviewsResponse} returns this
*/
proto.io.codedrills.proto.site.GetChildPreviewsResponse.prototype.setContentPreviewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse.prototype.addContentPreviews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.ContentPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.GetChildPreviewsResponse} returns this
 */
proto.io.codedrills.proto.site.GetChildPreviewsResponse.prototype.clearContentPreviewsList = function() {
  return this.setContentPreviewsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetRestrictedContestsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetRestrictedContestsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetRestrictedContestsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetRestrictedContestsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetRestrictedContestsRequest}
 */
proto.io.codedrills.proto.site.GetRestrictedContestsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetRestrictedContestsRequest;
  return proto.io.codedrills.proto.site.GetRestrictedContestsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetRestrictedContestsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetRestrictedContestsRequest}
 */
proto.io.codedrills.proto.site.GetRestrictedContestsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetRestrictedContestsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetRestrictedContestsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetRestrictedContestsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetRestrictedContestsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.GetRestrictedContestsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.GetRestrictedContestsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    restrictedContestList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.GetRestrictedContestsResponse}
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.GetRestrictedContestsResponse;
  return proto.io.codedrills.proto.site.GetRestrictedContestsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.GetRestrictedContestsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.GetRestrictedContestsResponse}
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setRestrictedContestList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.GetRestrictedContestsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.GetRestrictedContestsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRestrictedContestList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 restricted_contest = 1;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.prototype.getRestrictedContestList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.site.GetRestrictedContestsResponse} returns this
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.prototype.setRestrictedContestList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.site.GetRestrictedContestsResponse} returns this
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.prototype.addRestrictedContest = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.GetRestrictedContestsResponse} returns this
 */
proto.io.codedrills.proto.site.GetRestrictedContestsResponse.prototype.clearRestrictedContestList = function() {
  return this.setRestrictedContestList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.RefreshScoreboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.RefreshScoreboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.RefreshScoreboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.RefreshScoreboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.RefreshScoreboardRequest}
 */
proto.io.codedrills.proto.site.RefreshScoreboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.RefreshScoreboardRequest;
  return proto.io.codedrills.proto.site.RefreshScoreboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.RefreshScoreboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.RefreshScoreboardRequest}
 */
proto.io.codedrills.proto.site.RefreshScoreboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.RefreshScoreboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.RefreshScoreboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.RefreshScoreboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.RefreshScoreboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.site.RefreshScoreboardRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.site.RefreshScoreboardRequest} returns this
*/
proto.io.codedrills.proto.site.RefreshScoreboardRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.site.RefreshScoreboardRequest} returns this
 */
proto.io.codedrills.proto.site.RefreshScoreboardRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.site.RefreshScoreboardRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.RefreshScoreboardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.RefreshScoreboardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.RefreshScoreboardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.RefreshScoreboardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.RefreshScoreboardResponse}
 */
proto.io.codedrills.proto.site.RefreshScoreboardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.RefreshScoreboardResponse;
  return proto.io.codedrills.proto.site.RefreshScoreboardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.RefreshScoreboardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.RefreshScoreboardResponse}
 */
proto.io.codedrills.proto.site.RefreshScoreboardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.RefreshScoreboardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.RefreshScoreboardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.RefreshScoreboardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.RefreshScoreboardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.FetchCustomerAllTestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.FetchCustomerAllTestRequest}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.FetchCustomerAllTestRequest;
  return proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.FetchCustomerAllTestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.FetchCustomerAllTestRequest}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.FetchCustomerAllTestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 customer_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.site.FetchCustomerAllTestRequest} returns this
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.FetchCustomerAllTestResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    testPreviewList: jspb.Message.toObjectList(msg.getTestPreviewList(),
    io_codedrills_proto_content_preview_pb.ContentPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.FetchCustomerAllTestResponse}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.FetchCustomerAllTestResponse;
  return proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.FetchCustomerAllTestResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.FetchCustomerAllTestResponse}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.addTestPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.FetchCustomerAllTestResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestPreviewList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.ContentPreview test_preview = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.ContentPreview>}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.prototype.getTestPreviewList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ContentPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ContentPreview>} value
 * @return {!proto.io.codedrills.proto.site.FetchCustomerAllTestResponse} returns this
*/
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.prototype.setTestPreviewList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.prototype.addTestPreview = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.ContentPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.FetchCustomerAllTestResponse} returns this
 */
proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.prototype.clearTestPreviewList = function() {
  return this.setTestPreviewList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.ListCustomerContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.ListCustomerContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    contentType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.ListCustomerContentRequest}
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.ListCustomerContentRequest;
  return proto.io.codedrills.proto.site.ListCustomerContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.ListCustomerContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.ListCustomerContentRequest}
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setContentType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.ListCustomerContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.ListCustomerContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getContentType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int32 customer_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.site.ListCustomerContentRequest} returns this
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional io.codedrills.proto.content.ContentType content_type = 2;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest.prototype.getContentType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.site.ListCustomerContentRequest} returns this
 */
proto.io.codedrills.proto.site.ListCustomerContentRequest.prototype.setContentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.site.ListCustomerContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.site.ListCustomerContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentPreviewList: jspb.Message.toObjectList(msg.getContentPreviewList(),
    io_codedrills_proto_content_preview_pb.ContentPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.site.ListCustomerContentResponse}
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.site.ListCustomerContentResponse;
  return proto.io.codedrills.proto.site.ListCustomerContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.site.ListCustomerContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.site.ListCustomerContentResponse}
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.addContentPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.site.ListCustomerContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.site.ListCustomerContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentPreviewList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.ContentPreview content_preview = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.ContentPreview>}
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse.prototype.getContentPreviewList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ContentPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ContentPreview>} value
 * @return {!proto.io.codedrills.proto.site.ListCustomerContentResponse} returns this
*/
proto.io.codedrills.proto.site.ListCustomerContentResponse.prototype.setContentPreviewList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse.prototype.addContentPreview = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.ContentPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.site.ListCustomerContentResponse} returns this
 */
proto.io.codedrills.proto.site.ListCustomerContentResponse.prototype.clearContentPreviewList = function() {
  return this.setContentPreviewList([]);
};


/**
 * @enum {number}
 */
proto.io.codedrills.proto.site.DataType = {
  SUMMARY: 0,
  FULL: 1
};

goog.object.extend(exports, proto.io.codedrills.proto.site);
